import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Error } from '../../components';
import { SegmentCarouselDisplay } from '../../components/ui/SegmentCarouselDisplay';
import {
  fetchProduct,
  fetchProductSegments,
} from '../../redux/modules/product';

const ProductPreview = () => {
  const dispatch = useDispatch();
  const { productId } = useParams();
  const {
    product,
    segments,
    // loading,
    // segmentsLoading,
    error,
    segmentsError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    // Only fetch if we don't already have the data (from server-side injection)
    if (!product) {
      dispatch(fetchProduct(productId));
    }
    if (!segments || segments.length === 0) {
      dispatch(fetchProductSegments(productId));
    }
  }, [dispatch, productId, product, segments]);

  // if (loading || segmentsLoading) return <Loader />;
  if (error || segmentsError) return <Error error={error || segmentsError} />;

  return (
    <div className="container">
      <SegmentCarouselDisplay segments={segments || []} />
    </div>
  );
};

export default ProductPreview;
